import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=6ab3e5f4&scoped=true&"
import script from "./DownloadList.vue?vue&type=script&lang=js&"
export * from "./DownloadList.vue?vue&type=script&lang=js&"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=6ab3e5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab3e5f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab3e5f4')) {
      api.createRecord('6ab3e5f4', component.options)
    } else {
      api.reload('6ab3e5f4', component.options)
    }
    module.hot.accept("./DownloadList.vue?vue&type=template&id=6ab3e5f4&scoped=true&", function () {
      api.rerender('6ab3e5f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/DownloadList.vue"
export default component.exports